import { Trash2, RotateCcw } from 'lucide-react';
import { Button, Card, ThemeToggle } from '@/components/common';
import { useSettingsStore, useStatsStore, useLearningStore, useAchievementsStore } from '@/store';

export function SettingsPage() {
  const settings = useSettingsStore();
  const statsStore = useStatsStore();
  const learningStore = useLearningStore();
  const achievementsStore = useAchievementsStore();

  const handleResetStats = () => {
    if (window.confirm('Are you sure you want to reset all statistics? This cannot be undone.')) {
      statsStore.reset();
    }
  };

  const handleResetProgress = () => {
    if (window.confirm('Are you sure you want to reset all learning progress? This cannot be undone.')) {
      learningStore.reset();
    }
  };

  const handleResetAll = () => {
    if (window.confirm('Are you sure you want to reset ALL data including stats, progress, and settings? This cannot be undone.')) {
      statsStore.reset();
      learningStore.reset();
      achievementsStore.reset();
      settings.reset();
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>

      {/* Theme */}
      <Card>
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium text-stone-900 dark:text-stone-100">Theme</h3>
            <p className="text-sm text-stone-500">Choose light, dark, or system</p>
          </div>
          <ThemeToggle />
        </div>
      </Card>

      {/* Data management */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-stone-900 dark:text-stone-100">Data Management</h2>

        <Card className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium text-stone-900 dark:text-stone-100">Reset Statistics</h3>
              <p className="text-sm text-stone-500">Clear all quiz history and stats</p>
            </div>
            <Button
              variant="secondary"
              size="sm"
              onClick={handleResetStats}
              className="flex items-center gap-2"
            >
              <RotateCcw className="w-4 h-4" />
              Reset
            </Button>
          </div>

          <div className="border-t border-stone-100 dark:border-stone-800" />

          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium text-stone-900 dark:text-stone-100">Reset Learning Progress</h3>
              <p className="text-sm text-stone-500">Clear spaced repetition data</p>
            </div>
            <Button
              variant="secondary"
              size="sm"
              onClick={handleResetProgress}
              className="flex items-center gap-2"
            >
              <RotateCcw className="w-4 h-4" />
              Reset
            </Button>
          </div>

          <div className="border-t border-stone-100 dark:border-stone-800" />

          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium text-error-600 dark:text-error-400">
                Reset Everything
              </h3>
              <p className="text-sm text-stone-500">Delete all data and settings</p>
            </div>
            <Button
              variant="error"
              size="sm"
              onClick={handleResetAll}
              className="flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Delete All
            </Button>
          </div>
        </Card>
      </div>

      {/* About */}
      <Card className="text-center text-sm text-stone-500">
        <p>Flag Trainer v0.1.0</p>
        <p className="mt-1">
          Flag data from{' '}
          <a
            href="https://flagcdn.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-500 hover:underline"
          >
            flagcdn.com
          </a>
        </p>
      </Card>
    </div>
  );
}
